import React from 'react';
import type { ReactNode } from 'react';
import { createContext, useContext } from 'react';
import { useNotificationCenter } from 'react-toastify/addons/use-notification-center';

const NotificationsContext = createContext<
  ReturnType<typeof useNotificationCenter> | undefined
>(undefined);

export function NotificationsProvider({ children }: { children: ReactNode }) {
  const value = useNotificationCenter<{ dismissible?: boolean }>({
    filter: (item) => !item.data?.dismissible, // filter out dismissible notifications
  });
  return (
    <NotificationsContext.Provider value={value}>
      {children}
    </NotificationsContext.Provider>
  );
}

export function useSharedNotificationCenter() {
  const context = useContext(NotificationsContext);
  if (!context) {
    throw new Error(
      'useSharedNotificationCenter must be used within NotificationsProvider',
    );
  }
  return context;
}
